import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

import { LoadingService } from './loading-progress-bar.service';

@Injectable({
  providedIn: 'root'
})
export class ExportNewService {

  constructor(private loadingService: LoadingService) { }
  public exportExcel(jsonData: any[], excelHeader: any, fileName: string): void {
    this.onExportExcel(jsonData, excelHeader, fileName);
  }

  private async onExportExcel(jsonData: any[], excelHeader: any, fileName: string) {
    this.loadingService.setLoading(true);
    let dataRows: any[] = [];
    let cells: any[] = [];

    // Header Row Adding
    excelHeader.forEach((x: string) => {
      cells = [];
      Object.keys(x).forEach((prop: any) => {
        cells.push(x[prop]);
      });
      dataRows.push(cells);
    });
    
    // Value Row Adding
    jsonData.forEach((x: any) => {
      cells = [];
      Object.keys(x).forEach((prop: any) => {
        cells.push(x[prop]);
      })

      dataRows.push(cells);
    });

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(dataRows, {skipHeader: true});
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet1');
    XLSX.writeFile(workbook, fileName,  {
      bookSST: true, compression: true, bookType: 'xlsx' 
    });

    this.loadingService.setLoading(false);

  }

}
